import { render } from "./destination-point-of-interest.vue?vue&type=template&id=69cf9b94"
import script from "./destination-point-of-interest.vue?vue&type=script&lang=js"
export * from "./destination-point-of-interest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__